import styled from 'styled-components';

export const SuccessOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.7);

  .card {
    width: 100%;
    max-width: 420px;
    padding: 32px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;
    text-align: center;
  }

  .icon-wrap {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(3, 160, 141, 0.12);
    border: 1px solid rgba(3, 160, 141, 0.3);
    color: var(--primary);
  }

  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: var(--white);
  }

  p {
    margin: 0 auto;
    max-width: 280px;
    font-size: 14px;
    line-height: 22px;
    color: #a0a0a0;
  }

  .continue {
    width: 100%;
    margin-top: 24px;
    padding: 10px 16px;
    border: 0;
    border-radius: 8px;
    background: var(--primary);
    color: var(--white);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const StyledAgentCreated = styled.div``;
